import "./BlockPreview.scss";
import { BlockPreviewProps } from "/Models/Generated/BlockPreviewProps";
import { ContentAreaType } from "/Models/Generated/ContentAreaType";
import { ContentAreaProps } from "/Models/Generated/ContentAreaProps";
import { ComponentWrapperProps } from "/Models/Generated/ComponentWrapperProps";
import {
  ContentArea,
  GridPresetMainContent,
  GridPresetWideContent,
  GridRow,
} from "/App.Components";

const BuildDummyContentArea = (
  items: ComponentWrapperProps[],
  contentAreaType: ContentAreaType
): ContentAreaProps => {
  return {
    contentAreaType,
    items,
  };
};

const BuildDummyRichText = (): ComponentWrapperProps => ({
  name: "RichText",
  component: {
    html:
      "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis " +
      "condimentum lacus hendrerit, consectetur purus non, viverra dui. " +
      "Phasellus non dictum libero. Cras diam sem, pretium ac commodo id, " +
      "bibendum quis lacus. Vestibulum vulputate lacus eget blandit elementum. " +
      "Fusce venenatis, risus eget semper pretium, tortor elit congue metus, " +
      "in vestibulum odio enim id nisi. Nam mi turpis, auctor aliquet metus eu, " +
      "accumsan finibus sapien.</p>",
  },
});

const FeaturedLinkBlock = ({ block }: BlockPreviewProps) => {
  if (typeof block === "undefined") return null;
  return (
    <div className="block-preview-norad">
      <GridRow>
        <GridPresetMainContent>
          <ContentArea
            {...BuildDummyContentArea(
              [BuildDummyRichText(), block, BuildDummyRichText()],
              ContentAreaType.RichText
            )}
          />
        </GridPresetMainContent>
      </GridRow>
      <GridRow>
        <GridPresetWideContent>
          <ContentArea
            {...BuildDummyContentArea(
              [block, block, block],
              ContentAreaType.RichText
            )}
          />
        </GridPresetWideContent>
      </GridRow>
    </div>
  );
};

export default FeaturedLinkBlock;
